<template>
  <div>
    <PageTitle v-bind:title="'Issue Vars'" />

    <b-container fluid="xxl" class="mt-2">
      <b-row class="mt-4">
        <b-col>
          <b-button
            v-if="config.editable"
            variant="primary"
            size="sm"
            :disabled="!$store.getters.checkRole('legam.scripta.issuevar.add')"
            class="float-right mb-4"
            v-b-modal.modal-new-issuevar
          >
            <b-icon icon="plus-circle-fill" aria-hidden="true"></b-icon>
            Add new issue var
          </b-button>
          <b-modal
            v-if="config.editable"
            id="modal-new-issuevar"
            title="New issue var"
            ok-title="Save"
            @ok="saveIssuevar"
            size="lg"
          >
            <IssueVarNewEdit />
          </b-modal>
          <LegamDataTables v-bind="$data" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
* >>> .tdAction {
  width: 150px;
}
</style>

<script>
// import { mapState } from 'vuex'
import router from "@/router";
import PageTitle from "@/components/PageTitle.vue";
import LegamDataTables from "@/components/LegamDataTables.vue";
import tdColAction from "@/components/tdColAction";
import IssueVarNewEdit from "@/components/Scripta/IssueVarNewEdit";
import HelpStore from "@/store/helpstore.js";
import config from '@/config.js'

export default {
  name: "IssueVars",
  data() {
    return {
      columns: [
        {
          title: "Form",
          field: "form",
          sortable: true,
          searchable: true,
        },
        {
          title: "Comment",
          field: "comment",
          sortable: true,
          searchable: true,
        },
        {
          title: "Heads",
          field: "heads",
          tdComp: tdColAction,
          sortable: true,
          searchable: true,
          transformData: function (row) {
            return row.heads.map(head => {
              return {
                text: head.form,
                icon: null,
                id: head.id,
                to: {
                  name: "HeadDetails",
                  params: {
                    id: head.id,
                  },
                },
              }
            })
          }
        },
        {
          title: "Action",
          field: "action",
          tdComp: tdColAction,
          thClass: "tdAction",
          transformData: function (row) {
            return [
              {
                text: null,
                icon: "list-ul",
                id: row.id,
                to: {
                  name: "IssueVarDetails",
                  params: {
                    id: row.id,
                  },
                },
              },
            ];
          },
        },
      ],
      url: "/issuevars/datatables",
      searchableByColumn: true,
      config: config
    };
  },
  components: {
    PageTitle,
    LegamDataTables,
    IssueVarNewEdit,
  },
  methods: {
    saveIssuevar() {
      this.$store.dispatch("createIssuevar", HelpStore.item).then((response) => {
        router.push(`/issuevar/${response.data.id}`);
      });
    },
  },
};
</script>
